import React, { useState, useEffect } from "react";
import "./SelecionarFornecedor.css";
import api from '../../../services/api';
import API_CONFIG from '../../../config/api.config';
import { message } from 'antd';

export default function SelecionarFornecedor({ onClose, onConfirm, solicitacaoId, itensFaltantes }) {
  const [selecionados, setSelecionados] = useState([]);
  const [busca, setBusca] = useState("");
  const [fornecedores, setFornecedores] = useState([]);
  const [loading, setLoading] = useState(false);
  const [paginacao, setPaginacao] = useState(null);
  const [paginaAtual, setPaginaAtual] = useState(1);

  const buscarFornecedores = async (pagina = 1, buscaNome = busca) => {
    setLoading(true);
    try {
      const params = { page: pagina, per_page: 8 };
      // Se quiser implementar busca na API, descomente a linha abaixo e ajuste o backend
      // if (buscaNome) params.nome = buscaNome;
      const response = await api.get(API_CONFIG.ENDPOINTS.FORNECEDOR.CONSULTAR_FOR, { params });
      if (response.data.status && response.data.fornecedores) {
        setPaginacao(response.data.fornecedores);
        setFornecedores(response.data.fornecedores.data.map(f => ({
          id: f.FOR_ID,
          nome: f.FOR_RAZAO_SOCIAL,
          cnpj: f.FOR_CNPJ,
          endereco: `${f.endereco?.END_LOGRADOURO || ''}, ${f.endereco?.END_CIDADE || ''}`
        })));
        setPaginaAtual(response.data.fornecedores.current_page);
      } else {
        setFornecedores([]);
        setPaginacao(null);
      }
    } catch (error) {
      setFornecedores([]);
      setPaginacao(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    buscarFornecedores(1);
    // eslint-disable-next-line
  }, []);

  const handleSelecionar = (index) => {
    setSelecionados((prev) =>
      prev.includes(index)
        ? prev.filter((i) => i !== index)
        : [...prev, index]
    );
  };

  // Busca local (frontend)
  const fornecedoresFiltrados = fornecedores.filter((f) =>
    f.nome.toLowerCase().includes(busca.toLowerCase())
  );

  // Paginação
  const handlePagina = (page) => {
    buscarFornecedores(page);
  };

  // Gerar botões de página
  const totalPages = paginacao?.last_page || 1;
  const pageButtons = [];
  for (let i = 1; i <= totalPages; i++) {
    pageButtons.push(
      <button
        key={i}
        className={i === paginaAtual ? "pagina-ativa" : ""}
        onClick={() => handlePagina(i)}
        disabled={i === paginaAtual}
      >
        {i}
      </button>
    );
  }

  return (
    <div className="modal-fornecedor">
      <div className="modal-content-fornecedor">
        <button className="fechar-modal" onClick={onClose}>&times;</button>
        <h2 className="titulo-modal">Selecionar Fornecedores</h2>
        <input
          className="input-busca"
          type="text"
          placeholder="Buscar fornecedores..."
          value={busca}
          onChange={(e) => setBusca(e.target.value)}
        />
        <div className="lista-fornecedores" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          {loading ? (
            <div>Carregando fornecedores...</div>
          ) : fornecedoresFiltrados.length === 0 ? (
            <div>Nenhum fornecedor encontrado.</div>
          ) : (
            fornecedoresFiltrados.map((f, i) => (
              <label className="item-fornecedor card-fornecedor" key={f.id} style={{ width: '100%', maxWidth: 400, margin: '0 auto 16px auto', borderRadius: 12, boxShadow: '0 2px 12px rgba(0,31,77,0.10)', border: '1.5px solid #e0e0e0', padding: 16, background: '#fff', display: 'flex', alignItems: 'flex-start', gap: 12 }}>
                <input
                  type="checkbox"
                  checked={selecionados.includes(f.id)}
                  onChange={() => handleSelecionar(f.id)}
                  style={{ marginTop: 4 }}
                />
                <div style={{ flex: 1 }}>
                  <div className="nome-fornecedor" style={{ fontWeight: 700, fontSize: '1.13rem', color: '#001f4d', marginBottom: 2 }}>{f.nome}</div>
                  <div className="cnpj-fornecedor" style={{ color: '#666', fontSize: '1rem', marginBottom: 1 }}>CNPJ: {f.cnpj}</div>
                  <div className="endereco-fornecedor" style={{ color: '#666', fontSize: '1rem', marginBottom: 1 }}>{f.endereco}</div>
                </div>
              </label>
            ))
          )}
        </div>
        <div className="paginacao">
          <button onClick={() => handlePagina(paginaAtual - 1)} disabled={paginaAtual <= 1}>{"<"}</button>
          {pageButtons}
          <button onClick={() => handlePagina(paginaAtual + 1)} disabled={paginaAtual >= totalPages}>{">"}</button>
        </div>
        <div className="botoes-modal">
          <button className="btn-cancelar" onClick={onClose}>Cancelar</button>
          <button
            className="btn-confirmar"
            onClick={async () => {
              try {
                const payload = {
                  SOL_ID: solicitacaoId,
                  FOR_ID: selecionados
                };
                //console.log('Payload enviado:', payload);
                const response = await api.post(API_CONFIG.ENDPOINTS.SOLICITACOES.ENVIAR, payload);
                if (response.data.status) {
                  message.success(response.data.message || response.data.mensagem || 'Solicitação enviada para os fornecedores selecionados!');
                  if (onClose) onClose();
                } else {
                  message.error(response.data.message || response.data.mensagem || 'Erro ao enviar solicitação para fornecedores.');
                }
              } catch (e) {
                message.error('Erro ao enviar solicitação para fornecedores.');
              }
            }}
          >
            Confirmar Envio
          </button>
        </div>
      </div>
    </div>
  );
}